import Raven from 'raven-js';
import ACBadRequestError from './ACBadRequestError';
import ACMissingContentError from './ACMissingContentError';
import ACForbiddenError from './ACForbiddenError';
import ACRetiredContentError from './ACRetiredContentError';
import { useEffect } from 'react';
import { ConditionalNavMarker } from '../../features/rhumb/components/ConditionalNavMarker';
import { jsx as _jsx } from "react/jsx-runtime";
const isPublishableContentType = contentType => {
  if (!contentType) return false;
  return ['TRACK', 'COURSE', 'LESSON', 'SHORT_FORM_CONTENT'].includes(contentType);
};
const getPlainErrorObject = error => {
  var _toJS, _toJS2, _ref;
  return (_toJS = error === null || error === void 0 || (_toJS2 = (_ref = error).toJS) === null || _toJS2 === void 0 ? void 0 : _toJS2.call(_ref)) !== null && _toJS !== void 0 ? _toJS : error;
};
const getStatusFromHubError = error => {
  if (!error || typeof error === 'string') return null;
  const errorObj = getPlainErrorObject(error);
  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.status) || null;
};
const getStatusFromApolloError = error => {
  var _ref2, _ref3, _errorObj$networkErro, _errorObj$networkErro2, _errorObj$networkErro3;
  if (!error || typeof error === 'string') return null;
  const errorObj = getPlainErrorObject(error);
  return (_ref2 = (_ref3 = (_errorObj$networkErro = errorObj === null || errorObj === void 0 || (_errorObj$networkErro2 = errorObj.networkError) === null || _errorObj$networkErro2 === void 0 ? void 0 : _errorObj$networkErro2.statusCode) !== null && _errorObj$networkErro !== void 0 ? _errorObj$networkErro : errorObj === null || errorObj === void 0 || (_errorObj$networkErro3 = errorObj.networkError) === null || _errorObj$networkErro3 === void 0 ? void 0 : _errorObj$networkErro3.status) !== null && _ref3 !== void 0 ? _ref3 : errorObj === null || errorObj === void 0 ? void 0 : errorObj.statusCode) !== null && _ref2 !== void 0 ? _ref2 : null;
};
const getErrorStatus = error => {
  var _ref4, _getStatusFromHubErro;
  return (_ref4 = (_getStatusFromHubErro = getStatusFromHubError(error)) !== null && _getStatusFromHubErro !== void 0 ? _getStatusFromHubErro : getStatusFromApolloError(error)) !== null && _ref4 !== void 0 ? _ref4 : 404;
};
const getErrorType = error => {
  var _ref5, _errorObj$networkErro4, _errorObj$networkErro5;
  if (!error || typeof error === 'string') return null;
  const errorObj = getPlainErrorObject(error);
  return (_ref5 = (_errorObj$networkErro4 = errorObj === null || errorObj === void 0 || (_errorObj$networkErro5 = errorObj.networkError) === null || _errorObj$networkErro5 === void 0 || (_errorObj$networkErro5 = _errorObj$networkErro5.cause) === null || _errorObj$networkErro5 === void 0 ? void 0 : _errorObj$networkErro5.errorType) !== null && _errorObj$networkErro4 !== void 0 ? _errorObj$networkErro4 : errorObj === null || errorObj === void 0 ? void 0 : errorObj.errorType) !== null && _ref5 !== void 0 ? _ref5 : null;
};
const ApiError = ({
  error,
  marker404,
  marker403,
  markerDefault,
  resetLink,
  showLink = true,
  contentType
}) => {
  const status = getErrorStatus(error);
  const errorType = getErrorType(error);
  useEffect(() => {
    if (![404, 403].includes(status)) {
      Raven.captureException(error, {
        extra: {
          errorType
        }
      });
    }
  }, [error, status, errorType]);
  if (status === 403 || errorType === 'TRACK_VISIBILITY_RESTRICTED') {
    return /*#__PURE__*/_jsx(ConditionalNavMarker, {
      name: marker403,
      children: /*#__PURE__*/_jsx(ACForbiddenError, {})
    });
  }
  switch (status) {
    case 404:
      {
        if (isPublishableContentType(contentType)) {
          return /*#__PURE__*/_jsx(ConditionalNavMarker, {
            name: marker404,
            children: /*#__PURE__*/_jsx(ACRetiredContentError, {
              contentType: contentType
            })
          });
        }
        return /*#__PURE__*/_jsx(ConditionalNavMarker, {
          name: marker404,
          children: /*#__PURE__*/_jsx(ACMissingContentError, {
            showLink: showLink
          })
        });
      }
    default:
      return /*#__PURE__*/_jsx(ConditionalNavMarker, {
        name: markerDefault,
        children: /*#__PURE__*/_jsx(ACBadRequestError, {
          to: resetLink
        })
      });
  }
};
export default ApiError;